import { Component } from '@angular/core';
import { LoaderService } from '../common/services/loader.service';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css'],
    standalone: false
})
export class SpinnerComponent {
  constructor(public loader: LoaderService) { }
}
